var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiggyBank26(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    style: {
      width: "1.125em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1152 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1120 448h-59c-17.6-40-43.2-75.4-74.8-105L1024 192h-64c-58.8 0-110.8 27-146 68.6-15.2-2.2-30.2-4.6-46-4.6H512c-154.8 0-283.8 110-313.6 256H112c-29.6 0-53-27-47-57.6C69.4 431.6 90.8 416 114 416h2c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12-57 0-107.8 40.8-115 97.2C-7.8 517.6 45.4 576 112 576h80c0 104.4 50.8 196.2 128 254.6V992c0 17.6 14.4 32 32 32h128c17.6 0 32-14.4 32-32v-96h256v96c0 17.6 14.4 32 32 32h128c17.6 0 32-14.4 32-32v-161.4c23.6-17.8 44.6-38.8 62.6-62.6H1120c17.6 0 32-14.4 32-32V480c0-17.6-14.4-32-32-32z m-256 128c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zM512 192h256c10.8 0 21.4 0.8 31.8 1.6 0-0.6 0.2-1 0.2-1.6 0-106-86-192-192-192s-192 86-192 192c0 4.2 1 8.2 1.2 12.4 30.4-7.8 62-12.4 94.8-12.4z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBank26);
export default __webpack_public_path__ + "static/media/piggy-bank-26.e40c0e832d7b1c70ac68c06274d2f615.svg";
export { ForwardRef as ReactComponent };